import type Theme from "@onestore/hel/dist/typings/theme"
import type { SectionSettings } from "@gatsby-plugin-generic-page/fragments/sectionSettings"
import getBackground from "./getBackground"
import getSectionSurfaceClass from "./getSectionSurfaceClass"
import { getBackgroundByTextColor } from "./sectionColor"

/**
 * The background a section's content reads its text color from
 * (`OnColorContext`). The text color of a custom color wins, otherwise the UDS
 * surface decides (inverted surfaces are dark). A background image lies on top
 * of that surface, so its text follows the surface as well.
 */
export default function getSectionOnColor(
  sectionSettings: Pick<SectionSettings, "customColor"> | undefined
): Theme.Color {
  const { customColor } = getBackground(sectionSettings?.customColor)

  return (
    getBackgroundByTextColor(customColor?.text) ??
    (getSectionSurfaceClass(sectionSettings)?.endsWith("-invert")
      ? // Not `backgroundDark`: the ionos theme (AZ, IONOS brands) makes that
        // one light gray with dark text. `backgroundDarker` is dark with
        // light text in every HEL theme.
        "backgroundDarker"
      : "backgroundLight")
  )
}
